export interface LongVideoQueueReadiness {
  renderStatus: string | null;
  hasVideoUrl: boolean;
  hasMetadata: boolean;
  hasTitle: boolean;
  hasConnectedAccount: boolean;
  accountId: string;
}

export function longVideoQueueBlockReason(readiness: LongVideoQueueReadiness): string | null {
  if (!readiness.renderStatus) return 'Loading the long-video render status…';
  if (readiness.renderStatus !== 'COMPLETED') return `Long video must finish rendering first (current status: ${readiness.renderStatus}).`;
  if (!readiness.hasVideoUrl) return 'The completed video preview is still loading. Use Refresh video status if this message remains.';
  if (!readiness.hasMetadata) return 'Generate YouTube metadata before scheduling this video.';
  if (!readiness.hasTitle) return 'Choose a final YouTube title before scheduling.';
  if (!readiness.hasConnectedAccount) return 'Connect an active BloodCrimes YouTube channel before scheduling.';
  if (!readiness.accountId) return 'Select the BloodCrimes YouTube channel.';
  return null;
}
